import React from "react";
import Badge from "../Badge";

const StatusColumn = ({ getValue, data }) => {
  let value;
  let variant;
  try {
    value = data ?? getValue ? getValue() : null;
    variant = "default";

    if (
      value === "active" ||
      value === "success" ||
      value === "SUCCESS" ||
      value === "ACCEPT" ||
      value === true ||
      value === "APPROVED" ||
      value === "REDEEMED" ||
      value === "WIN"
    ) {
      variant = "success";
    } else if (
      value === "inactive" ||
      value === "failed" ||
      value === "cancel" ||
      value === "FAILED" ||
      value === "REJECT" ||
      value === false ||
      value === "LOSE"
    ) {
      variant = "danger";
    } else if (value === "ACTIVATED") {
      variant = "success";
    }
  } catch (error) {
    value = false;
    variant = "default";
  }

  return (
    <div className="d-flex justify-content-center text-nowrap">
      <Badge variant={variant}>
        <span className="font-semibold">
          {typeof value != "boolean"
            ? value
            : value == true
              ? "Active"
              : "Inactive" ?? "-"}
        </span>
      </Badge>
    </div>
  );
};

export default StatusColumn;
